import * as React from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { getSeasonWinners } from "../api/FantasyAPI";
import WinnersTable from "./WinnersTable";
import { MenuProps, Header } from "./WeeklyWinners";
import { getYears, getMostRecentNFLSeasonAndWeek } from "../utils/utils";

export default function SeasonWinners() {
  const years = getYears();
  const [year, setYear] = React.useState("");
  const [seasonWinners, setSeasonWinners] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  React.useEffect(() => {
    const fetchMostRecentWeek = async () => {
      try {
        const mostRecent = await getMostRecentNFLSeasonAndWeek();
        setYear(mostRecent.season);
      } catch (err) {
        console.error(err);
      }
    };

    fetchMostRecentWeek();
  }, []);
    React.useEffect(() => {
      if (year !== "") {
        handleSubmit();
      }
    }, [year]);

  const handleSubmit = () => {
    setLoading(true);
    getSeasonWinners(year)
      .then((res) => {
        setSeasonWinners(res);
      })
      .catch((error) => {
        setErrorMessage("Could not load the season winners.");
        setError(true);
      })
      .finally(() => setLoading(false));
  };

  const handleCloseError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setError(false);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Header>Season Winners</Header>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="select-year-label" size="small">
          Year
        </InputLabel>
        <Select
          labelId="select-year-label"
          id="select-year"
          value={year}
          label="Year"
          onChange={handleYearChange}
          size="small"
          MenuProps={MenuProps}
        >
          {years.map((year, i) => (
            <MenuItem key={i} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <WinnersTable winners={seasonWinners} loading={loading} season={true} />

      <Snackbar open={error} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert
          onClose={handleCloseError}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
